import React from 'react';
import { useHistory } from 'react-router-dom';
import { Paper, Typography, Button, Box } from '@material-ui/core';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import HomeIcon from '@material-ui/icons/Home';
import PageContent from '../../Main/Content/mainContent';
import UIContainer from '../../UI/Container/UIContainer';

const AccessRestricted = ({ requiredLevel = 'Gerente' }) => {
  const history = useHistory();

  return (
    <PageContent>
      <UIContainer
        container
        direction="column"
        alignItems="center"
        justify="center"
        style={{ padding: '60px 20px', minHeight: '60vh' }}
      >
        <Paper
          elevation={3}
          style={{
            padding: '40px 32px',
            borderRadius: 16,
            textAlign: 'center',
            maxWidth: 480,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderTop: '4px solid #f59e0b',
          }}
        >
          <Box
            style={{
              backgroundColor: '#fef3c7',
              borderRadius: '50%',
              width: 64,
              height: 64,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 20,
            }}
          >
            <LockOutlinedIcon style={{ color: '#d97706', fontSize: 32 }} />
          </Box>

          <Typography
            variant="h5"
            style={{ fontWeight: 700, color: '#1e293b', marginBottom: 12 }}
          >
            Acesso Restrito
          </Typography>

          <Typography
            variant="body1"
            style={{ color: '#64748b', marginBottom: 28, lineHeight: 1.6 }}
          >
            Você não possui permissão para acessar esta seção. Este módulo é
            exclusivo para usuários com perfil de{' '}
            <strong style={{ color: '#1e293b' }}>{requiredLevel}</strong> (ou superior).
          </Typography>

          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<HomeIcon />}
            onClick={() => history.push('/home')}
            style={{
              backgroundColor: '#17497F',
              borderRadius: 10,
              padding: '10px 24px',
              fontWeight: 700,
              textTransform: 'none',
            }}
          >
            Voltar para o Início
          </Button>
        </Paper>
      </UIContainer>
    </PageContent>
  );
};

export default AccessRestricted;
